module.exports = __webpack_public_path__ + "img/level_two_lock.67eedab6.png";